<div class="container">
  <mat-card *ngIf="isLoading" style="margine-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <i class="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Loading
          details, please wait...
        </div>
        <div class="col-md-1"></div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="!isLoading" style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-11">
          <h1 class="mt-5">
            {{ managedSubscription.subscriptionTypeName }} Renewal / Update
          </h1>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="!isLoading && !donePurchasing && !processingCreditCard" style="margin-top: 15px">
    <mat-card-header>
      <mat-card-title>Apply Coupon</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="container">
        <form class="standard-form">
          <mat-form-field>
            <mat-label>Coupon or Trial Code</mat-label>
            <input matInput name="couponCode" [(ngModel)]="couponCode" />
          </mat-form-field>
          <button mat-raised-button class="piButton" (click)="getCouponOrPeriod()">
            Apply
          </button>
        </form>
        <span *ngIf="couponCodeError != ''" style="color: red">{{
          couponCodeError
          }}</span>
      </div>
    </mat-card-content>
  </mat-card>

  <ng-container *ngIf="!isLoading && !donePurchasing && !processingCreditCard">
    <mat-card *ngIf="renewingSubscription" style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Order Details</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-4">Price</div>
            <div class="col-md-2"></div>
            <div class="col-md-4" style="text-align: right">
              {{ orderPrice | currency }}
            </div>
            <div class="col-md-1"></div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-4">Discount</div>
            <div class="col-md-2"></div>
            <div class="col-md-4" style="text-align: right">
              {{ orderDiscount | currency }}
            </div>
            <div class="col-md-1"></div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-4">Total Due</div>
            <div class="col-md-2"></div>
            <div class="col-md-4" style="text-align: right">
              {{ orderTotalDue | currency }}
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Payment Information</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <div
            class="row"
            *ngIf="
              allowInvoice && !activatingSubscription && renewingSubscription
            "
          >
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <mat-radio-group
                name="orderPaymentMethod"
                [(ngModel)]="orderPaymentMethod"
              >
                <mat-radio-button value="CreditCard"
                  >Credit Card&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button
                >
                <mat-radio-button value="Invoice"
                  >Invoice&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button
                >
              </mat-radio-group>
            </div>
            <div class="col-md-1"></div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <form class="standard-form">
                <ng-container
                  *ngIf="
                    orderPaymentMethod == 'Invoice' && renewingSubscription
                  "
                >
                  <mat-form-field>
                    <mat-label>PO Number</mat-label>
                    <input matInput name="poNumber" [(ngModel)]="poNumber" />
                  </mat-form-field>
                </ng-container>
                <ng-container
                  *ngIf="
                    orderPaymentMethod == 'CreditCard' ||
                    !renewingSubscription ||
                    activatingSubscription
                  "
                >
                  <mat-checkbox
                    name="autoRenew"
                    *ngIf="!activatingSubscription && renewingSubscription"
                    [(ngModel)]="autoRenew"
                    >&nbsp;&nbsp;&nbsp;&nbsp;Auto Renew My
                    Subscription</mat-checkbox
                  >
                  <mat-form-field>
                    <mat-label>Card Number</mat-label>
                    <input matInput name="ccNumber" [(ngModel)]="ccNumber" />
                  </mat-form-field>
                  <table>
                    <tr>
                      <td>
                        <mat-form-field>
                          <mat-label>Expiration Date Month</mat-label>
                          <mat-select
                            name="ccExpirationMonth"
                            style="width: 100%"
                            [(ngModel)]="ccExpirationMonth"
                          >
                            <mat-option
                              *ngFor="let month of ccAvailableMonths"
                              [value]="month"
                              >{{ month }}</mat-option
                            >
                          </mat-select>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field>
                          <mat-label>Expiration Date Year</mat-label>
                          <mat-select
                            name="ccExpirationYear"
                            style="width: 100%"
                            [(ngModel)]="ccExpirationYear"
                          >
                            <mat-option
                              *ngFor="let year of ccAvailableYears"
                              [value]="year"
                              >{{ year }}</mat-option
                            >
                          </mat-select>
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field>
                          <mat-label>Card CVV</mat-label>
                          <input matInput name="ccCvv" [(ngModel)]="ccCvv" />
                        </mat-form-field>
                      </td>
                    </tr>
                  </table>
                </ng-container>
              </form>
            </div>
            <div class="col-md-1"></div>
          </div>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <button
                mat-raised-button
                class="piButton"
                (click)="processPayment()"
              >
                Submit
              </button>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="processingCreditCard && !donePurchasing">
    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Processing Purchase</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <i class="fas fa-spinner fa-pulse"></i
              >&nbsp;&nbsp;&nbsp;Processing your order, please wait...
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="donePurchasing">
    <mat-card style="margin-top: 15px">
      <mat-card-header>
        <mat-card-title>Purchase Complete</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="container">
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <i class="fa fa-check-square"></i>&nbsp;&nbsp;&nbsp;Thank you for
              your purchase, you can view your subscription under subscription
              management.
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </ng-container>

  <iframe style="display: none" [src]="payPalUrl"> </iframe>
</div>
